import './styles/burger.css'

export default function Burger({handler,active,type}) {

  if(type === 'faq'){
    return (
      <button onClick={handler} id='modal-toggle' className={active ? 'burger dark active' : 'burger dark'}>
        <span id='modal-toggle'></span>
        <span id='modal-toggle'></span>
        <span id='modal-toggle'></span>
      </button>
    )
  }

  return (
    <button onClick={handler} id='modal-toggle' className={active ? 'burger active' : 'burger'}>
      <span id='modal-toggle'></span>
      <span id='modal-toggle'></span>
      <span id='modal-toggle'></span>
    </button>
  )
}
